import React from 'react';

import { Box, Heading, Link } from '@betterment/samba-react';

const EMAIL = 'support@betterment.com';
export const ActivityError: React.FC = () => {
  return (
    <Box
      css={{
        paddingY: 'space.800',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Heading variant="title200" css={{ marginBottom: 'space.200' }}>
        Unable to complete request.
      </Heading>
      <Box css={{ width: '50%', textAlign: 'center' }}>
        <p>
          We're sorry, we're working to resolve this issue. Please try again later. If the issue continues, contact us
          for help at{' '}
          <Link href={`mailto:${EMAIL}`} variant="textPrimary">
            {EMAIL}
          </Link>
          .
        </p>
      </Box>
    </Box>
  );
};
